/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';
import {QuestionnaireSettingsModel} from "../../models/questionnaire-settings-model";


export interface QuestionnaireSettingsGetParams {
    questionnaireGuid?: string;
}

export function questionnaireSettingsGet(http: HttpClient, rootUrl: string, params: QuestionnaireSettingsGetParams, headers: HttpHeaders, context?: HttpContext): Observable<StrictHttpResponse<QuestionnaireSettingsModel>> {
    const rb = new RequestBuilder(rootUrl, questionnaireSettingsGet.PATH, 'get');

    for (let headerKey of headers.keys()) {
        rb.header(headerKey, headers.get(headerKey));
    }

    if (params) {
        rb.path('questionnaireGuid', params.questionnaireGuid, {"style":"simple"});
    }

    return http.request(
        rb.build({ responseType: 'json', accept: '*/*', context })
    ).pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
            return r as StrictHttpResponse<QuestionnaireSettingsModel>;
        })
    );
}

questionnaireSettingsGet.PATH = '/api/v1/questionnaires/{questionnaireGuid}/settings';
